import React, {useRef, useState, useEffect} from 'react'

import request from '../utils/request'
import callInvokeNative from '../utils/callInvokeNative'
import {reContent} from '../utils/formatMessage'

import UseOpenNativeWrap from './useOpenNativeWrap'

import noComment from '../assets/images/no-comment.png'

const Comment = ({articleId, clientName, articleUrl, commentCount, setCommentCount}) => {
  const commentDomRef = useRef(null)

  const [commentList, setCommentList] = useState([])
  const [haveMoreComment, setHaveMoreComment] = useState(false)
  const [currentUserAccountId, setCurrentUserAccountId] = useState()

  // 获取评论列表
  const getCommentListRes = async (startRowKey = '') => {
    const param = {
      articleId,
      articleType: 'news',
      subCount: '3',
      startRowKey,
      limit: '3',
    }
    const data = await request.post('/unauthorize/commentH5/queryArticleComment', param)

    if (data.resultCode === 0) {
      const {commentList: list, hasMoreReplyComment, currAccountId} = data.data
      setCommentList(pre => [...pre, ...list])
      setHaveMoreComment(hasMoreReplyComment !== '0')
      setCurrentUserAccountId(currAccountId)
    }
  }

  const changeNativeCommentCount = (count) => {
    var param = {
      commentCount: count
    }
    callInvokeNative('commentCountChanged', param, null)
  }

  const commentCountCalc = (type, num = 1) => {
    // 闭包陷阱
    setCommentCount(preCount => {
      let preCommentCount = parseInt(preCount)
      if (type === 'add') {
        preCommentCount += num
      } else {
        preCommentCount -= num
      }

      changeNativeCommentCount(preCommentCount)
      return preCommentCount
    })
  }


  useEffect(() => {
    getCommentListRes() // 评论列表

    if (clientName === 'app') {
      // 注入原生所需的方法
      // 发起评论
      window.submitData = async (res) => {
        const {data} = JSON.parse(res.replace(/\n/g, '\\n').replace(/\r/g, '\\r'))

        const param = {
          articleType: 'news',
          articleId,
          content: data.content,
          replyCommentId: data.replyCommentId || '',
          topReplyCommentId: data.topReplyCommentId || '',
        }

        const resData = await request.post('/unauthorize/commentH5/createComment', param)

        if (resData.resultCode === 0) {
          const obj = resData.data
          if (data.replyCommentId) {
            // 二级回复
            setCommentList(pre => {
              const parent = pre[data.index]
              parent.replyCommentList = [...parent.replyCommentList, obj]
              parent.replyCommentCount = parseInt(parent.replyCommentCount) + 1
              return [
                ...pre.slice(0, data.index),
                parent,
                ...pre.slice(data.index + 1),
              ]
            })
          } else {
            // 添加一级回复
            obj.replyCommentList = obj.replyCommentList || []
            setCommentList(pre => [obj, ...pre])
          }
          // 增加评论数 并通知原生
          commentCountCalc('add')
        }
      }

      // 点击评论数 滚动到评论处
      window.changePosition = () => {
        commentDomRef.current.scrollIntoView(true)
      }
    }

    return () => {
      window.submitData = null
      window.changePosition = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onLoadMoreComment = (e) => {
    e.stopPropagation()

    const lastRowkey = commentList[commentList.length - 1].commentId

    getCommentListRes(lastRowkey)
  }

  const getMoreRepyComment = async (e, cur) => {
    e.stopPropagation()

    const lastRowkey = cur.replyCommentList[cur.replyCommentList.length - 1].commentId

    const param = {
      topCommentId: cur.commentId,
      startRowKey: lastRowkey,
      limit: 10,
    }

    const data = await request.post('/unauthorize/commentH5/querySubArticleComment', param)

    if (data.resultCode === 0) {
      const {commentList: list} = data.data
      cur.replyCommentList = [...cur.replyCommentList, ...list]
      setCommentList([...commentList])
    }
  }

  const onRetractComment = (e, cur) => {
    e.stopPropagation()

    cur.replyCommentList = cur.replyCommentList.slice(0, 3)

    setCommentList([...commentList])
  }

  const openProfile = (e, accountId, accountType = '2') => {
    e.stopPropagation()

    if (clientName !== 'app') {
      return
    }

    const param = {
      accountId,
      accountType
    }

    callInvokeNative('openProfile', param)
  }

  const onDeleteComment = async (e, cur) => {
    e.stopPropagation()

    if (!window.confirm('确认删除？')) {
      return
    }

    const param = {
      articleId,
      articleType: 'news',
      commentId: cur.commentId,
    }

    if (cur.topReplyCommentId) {
      param.topCommentId = cur.topReplyCommentId || ''
    }

    const data = await request.post('/unauthorize/commentH5/removeComment', param)

    if (data.resultCode === 0) {
      if (cur.topReplyCommentId) {
        // 删除二级评论
        const parent = commentList.find(item => item.commentId === cur.topReplyCommentId)
        parent.replyCommentList = parent.replyCommentList.filter(item => item.commentId !== cur.commentId)
        setCommentList([...commentList])
        commentCountCalc('remove')
      } else {
        // 删除一级评论
        setCommentList(commentList.filter(item => item.commentId !== cur.commentId))
        const removeNum = parseInt(cur.replyCommentCount) + 1
        commentCountCalc('remove', removeNum)
      }
    } else {
      window.alert(data.cause)
    }
  }

  const onReplayComment = (e, cur, index) => {
    e.stopPropagation()

    if (clientName !== 'app') {
      return
    }

    const param = {
      replyCommentId: cur.commentId,
      placeholder: `回复@${cur.accountName}`,
      index,
    }

    if (cur.topReplyCommentId) {
      param.topReplyCommentId = cur.topReplyCommentId
    }

    callInvokeNative('callNativeKeyboard', param)

    setTimeout(() => {
      e.target.scrollIntoView(true)
    }, 500)
  }

  return (
    <section className="warparea pb20" ref={commentDomRef}>
      <div className="ml25 mr25">
        <div className="fS16 mt20 mb20"><i
          className="comment-bg pinglun-txt-ico mr5"></i>全部评论(<span>{commentCount}</span>)
        </div>
        {
          commentList.map((item, index) => (
            <div className="mt10 pr" key={item.commentId}>
              <div className="comment-img" onClick={e => openProfile(e, item.accountId, item.accountType)}>
                <img src={item.headImgUrl} width="100%" alt="" />
              </div>
              <div className="comment-right">
                <div>
                  <span className="fS12 cgrayq">{item.accountName}</span>
                  <span className="fr fS12 cgray9 mt2">{item.createTime}</span>
                </div>
                <div
                  className="fS14"
                  dangerouslySetInnerHTML={{__html: reContent(item.content)}}
                  onClick={e => onReplayComment(e, item, index)}
                />
                {
                  item.accountId === currentUserAccountId && (
                    <div
                      className="cprompt fS12 pa-right"
                      onClick={e => onDeleteComment(e, item)}
                    >
                      删除
                    </div>
                  )
                }

                {/* <!--回复--> */}
                {
                  item.replyCommentCount > 0 && (
                    <div className="comment-hu">
                      {
                        item.replyCommentList.map((inner) => (
                          <div className="mt10 pr" key={inner.commentId}>
                            <div className="comment-img" onClick={e => openProfile(e, inner.accountId, inner.accountType)}>
                              <img src={inner.headImgUrl} width="100%" alt="" />
                            </div>
                            <div className="comment-right">
                              <div>
                                <span className="fS12 cgrayq">{inner.accountName}</span>
                                <span className="fr fS12 cgray9 mt2">{inner.createTime}</span>
                              </div>
                              <div className="fS14">
                                回复
                                <span className="cblue mr5">@{inner.replyAccountName}</span>
                                <div
                                  dangerouslySetInnerHTML={{__html: reContent(inner.content)}}
                                  onClick={e => onReplayComment(e, inner, index)}
                                />
                              </div>
                              {
                                inner.accountId === currentUserAccountId && (
                                  <div
                                    className="cprompt fS12 pa-right"
                                    onClick={e => onDeleteComment(e, inner)}
                                  >
                                    删除
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        ))
                      }

                      {
                        item.replyCommentCount > item.replyCommentList.length && item.replyCommentCount > 3 && (
                          <UseOpenNativeWrap
                            clientName={clientName}
                            articleUrl={articleUrl}
                            onClick={e => getMoreRepyComment(e, item)}
                          >
                            <div className="tc mt10">
                              <div className="cblue fS12">
                                查看全部{item.replyCommentCount}条回复
                                <i className="comment-bg pinglun-arr-down ml10"></i>
                              </div>
                            </div>
                          </UseOpenNativeWrap>

                        )
                      }

                      {
                        item.replyCommentList.length >= item.replyCommentCount && item.replyCommentCount > 3 && (
                          <div className="tc mt10" onClick={e => onRetractComment(e, item)}>
                            <div className="cblue fS12">
                              收起回复
                              <i className="comment-bg pinglun-arr-up ml10"></i>
                            </div>
                          </div>
                        )
                      }

                    </div>
                  )
                }
                {/* <!--回复结束--> */}
              </div>
            </div>
          ))
        }

        {
          haveMoreComment && commentList.length > 0 && clientName === 'app' && (
            <UseOpenNativeWrap
              clientName={clientName}
              articleUrl={articleUrl}
              onClick={onLoadMoreComment}
            >
              <div className="tc mt10">
                <div className="cblue fS12">加载更多评论</div>
              </div>
            </UseOpenNativeWrap>
          )
        }

        {/* 暂无评论 */}
        {
          commentList.length === 0 && (
            <div className="tc mb20">
              <img src={noComment} width="112" alt="" />
            </div>
          )
        }

        {
          clientName !== 'app' && (
            <UseOpenNativeWrap
              clientName={clientName}
              articleUrl={articleUrl}
            >
              <span className="btn-radius-full">打开渔歌医疗App参与评论</span>
            </UseOpenNativeWrap>
          )
        }

      </div>
    </section>
  )
}

export default Comment